module.exports = __webpack_public_path__ + "img/modelMarket3.37721f42.png";